import { EmployeeDetailsDto } from '../dto/employee-details.dto';

export type APIEmployeeResponse = {
  limit?: number;
  page?: number;
  data: Array<{
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    name: string;
    position: string;
    zone: string | null;
    globalId: string;
    role: string;
    jobFamily: string;
    workAddressCity: string;
    band: string;
    country: string;
    managerName: string;
    department?: string;
    departmentFunction?: string;
  }>;
  count: number;
  countGlobalAdmin: number;
  countZoneAdmin: number;
  countNoRole: number;
};

export type GetEmployeesAPIResponse = {
  employees: EmployeeDetailsDto[];
  count: number;
  countEligible: number;
  countNotEligible: number;
};

export function adaptEmployeeResponse(
  apiResponse: APIEmployeeResponse
): GetEmployeesAPIResponse {
  const fallback = (value?: string | null) => value?.trim() || 'Not available';

  return {
    employees: apiResponse.data.map(employee => ({
      id: employee.id,
      employeeName: employee.name,
      employeeGlobalId: employee.globalId,
      band: employee.band,
      employeeEmail: employee.email,
      positionTitle: employee.position,
      managerGlobalId: fallback(null),
      managerName: employee.managerName,
      zone: employee.zone,
      jobFamily: employee.jobFamily,
      workAddressCity: employee.workAddressCity,
      countryBU: employee.country,
      department: employee.department,
      departmentFunction: employee.departmentFunction,
    })),
    count: apiResponse.count,
    countEligible: apiResponse.countGlobalAdmin + apiResponse.countZoneAdmin,
    countNotEligible: apiResponse.countNoRole,
  };
}
